import React from 'react';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import TopFeatureList from '../../../components/TopFeature/TopFeatureList';
import messages from '../../../locale/messages';

class TopFeature extends React.Component {

    render() {
        const { formatMessage } = this.props.intl;

        return (
            <div >
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.aboutSectionSettings)}</h1>
                <TopFeatureList />
            </div>
        );
    }
}

export default compose(injectIntl)(TopFeature);
